import { FC } from "react";

import { cn } from "@/lib/cn";

import { User } from "../models/user-model";

import { UserAvatar } from "./user-avatar";
import { UserViewEmpty } from "./user-view-empty";

interface UserViewProps {
  user: User | null;
  logoOnly?: boolean;
  className?: string;
}

export const UserView: FC<UserViewProps> = ({ user, ...props }) => {
  if (!user) {
    return <UserViewEmpty {...props} data-testid="user-view-empty" />;
  }

  return (
    <div className="flex flex-row items-center gap-2" data-testid="user-view">
      <UserAvatar user={user} className={cn(["h-4 w-4", props.className])} />
      {!props.logoOnly && <div className="whitespace-nowrap">{user.username ?? user.email}</div>}
    </div>
  );
};
